import React, { CSSProperties, useRef } from 'react'
import * as styles from './index.module.less'
import classnames from 'classnames'
import VideoPlayer from 'components/VideoPlayer'
import icon from './img/navIcon.png'
import appointment from './img/appointment.png'
import signUp from './img/signUp.png'
import moment from './img/moment.png'
import review from './img/review.png'

interface NavProps {
  /**报名跳转链接 */
  signUpLink: string
  /**预约跳转链接 */
  appointmentLink: string
  /**是否是回顾页 */
  isReview?: boolean
  /**类名 */
  signUpClass?: CSSProperties
}

interface ExtendedCSSProperties extends CSSProperties {
  '--left-image': string
  '--right-image': string
}

const Nav: React.FC<NavProps> = (props) => {
  const { signUpLink, appointmentLink, isReview = false, signUpClass } = props

  const curVideo = useRef<any>(null) // 视频播放组件

  const linkStyle: ExtendedCSSProperties = {
    '--left-image': `url(${isReview ? moment : signUp})`,
    '--right-image': `url(${isReview ? review : appointment})`,
  }
  const handleClick = () => {
    if (isReview) {
      curVideo?.current.playVideo()
    }
  }

  return (
    <div className={styles.navWrapper}>
      <div className={styles.content} style={linkStyle}>
        <img className={styles.icon} src={icon} />
        <div className={styles.right}>
          <div className={classnames(styles.signUp, signUpClass)} onClick={isReview ? handleClick : undefined}>
            {!isReview && <a href={signUpLink} className={styles.link}></a>}
          </div>
          <div className={styles.appointment}>
            <a href={appointmentLink} className={styles.link}></a>
          </div>
          <div className={styles.backHome}>
            <div className={styles.text}>返回官网首页</div>
            <div className={styles.homeWrapper}>
              <div className={styles.home}></div>
            </div>
            <a href="https://www.sensorsdata.cn/" className={styles.homeLink}></a>
          </div>
        </div>
      </div>
      {isReview && (
        <VideoPlayer
          videoOpt={{
            sources: isReview ? signUpLink : '',
          }}
          fuRef={curVideo}
        />
      )}
    </div>
  )
}

export default Nav
